import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getSearchUrl as _ } from '../../utils/urls';
import { SALE, RENT, RENTDAILY, APARTMENTS, LANDS, COMMERCIALS, GARAGES } from '../../consts';
import {
  SALE_APARTMENTS_NEWBUILDING, RENT_APARTMENTS_HOUSE_COTTAGE, RENTDAILY_COTTAGE,
  RESIDENTIAL_COMPLEX, COTTAGE_VILLAGE
} from '../../utils/aliases';

import UserMenu from './UserMenu';
import CianUnion from '../CianUnion/CianUnion';

class MainMenu extends React.Component {
  render () {
    const path = this.props.location.pathname;

    const isUser = this.props.user && (this.props.user.getIn(['data', 'id']) || 0);
    const isMls = (isUser && this.props.user.getIn(['data', 'hasMls'], false)) || false;

    const saleClass = [
      /^\/pokupka-[a-z0-9\\-]/.test(path)
    ].filter(x => x).length ? ' active' : '';

    const rentClass = [
      /^\/arenda-[a-z0-9\\-]/.test(path),
      /^\/posutochnaja-arenda-[a-z0-9\\-]/.test(path)
    ].filter(x => x).length ? ' active' : '';

    const newBuildingClass = [
      path === '/zhilye-kompleksy/'
    ].filter(x => x).length ? ' active' : '';

    const moreClass = [
      path === '/office/statistic/',
      path === '/rieltory/',
      path === '/articles/'
    ].filter(x => x).length ? ' active' : '';

    return (
      <header className='main-header clearfix no-print'>
        <a href='/' className='icon-logo clearfix'>
          <span className='icon-logo_m'>
            <span className='path1' />
            <span className='path2' />
          </span>
          <span className='icon-logo_l'>
            <span className='path1' />
            <span className='path2' />
          </span>
          <span className='icon-logo_s'>
            <span className='path1' />
            <span className='path2' />
          </span>
          <span className='icon-logo_n'>
            <span className='path1' />
            <span className='path2' />
          </span>
        </a>
        <div className='cian-union-block'>
          <span className='icon-logo-union' />
          <CianUnion>
            <span className='icon-logo-cian-new' data-tip data-for='tip-mlsn-union-cian'>
              <span className='path1' />
              <span className='path2' />
              <span className='path3' />
              <span className='path4' />
              <span className='path5' />
              <span className='path6' />
            </span>
          </CianUnion>
        </div>

        <nav>
          <ul className='main-menu'>
            <li className={`popup-menu${saleClass}`}>
              <div data-title='Продажа'>
                <span>Продажа</span>
              </div>
              <ul className='popup'>
                <li><a href={_(SALE, APARTMENTS)}>Квартиры, комнаты</a></li>
                <li><a href={SALE_APARTMENTS_NEWBUILDING}>Квартиры в новостройках</a></li>
                <li><a href={_(SALE, LANDS)}>Дома, участки, дачи</a></li>
                <li><a href={COTTAGE_VILLAGE}>Коттеджные поселки</a></li>
                <li><a href={_(SALE, COMMERCIALS)}>Коммерческая недвижимость</a></li>
                <li><a href={_(SALE, GARAGES)}>Гаражи</a></li>
                <li><a href={'/office/saleDemand/'}>Спрос</a></li>
              </ul>
            </li>
            <li className={`popup-menu${rentClass}`}>
              <div data-title='Аренда'>
                <span>Аренда</span>
              </div>
              <ul className='popup'>
                <li><a href={_(RENT, APARTMENTS) + (isMls ? '?isMls=1' : '')}>Квартиры, комнаты</a></li>
                <li><a href={RENT_APARTMENTS_HOUSE_COTTAGE + (isMls ? '?isMls=1' : '')}>Дома, коттеджи</a></li>
                <li><a href={_(RENTDAILY, APARTMENTS)}>Квартиры посуточно</a></li>
                <li><a href={RENTDAILY_COTTAGE}>Коттеджи посуточно</a></li>
                <li><a href={_(RENT, COMMERCIALS)}>Коммерческая недвижимость</a></li>
                <li><a href={'/office/rentDemand/'}>Спрос</a></li>
              </ul>
            </li>

            <li className={`popup-menu${newBuildingClass}`}>
              <div data-title='Новостройки'>
                <span>Новостройки</span>
              </div>
              <ul className='popup'>
                <li><a href={SALE_APARTMENTS_NEWBUILDING}>Квартиры в новостройках</a></li>
                <li><a href={RESIDENTIAL_COMPLEX}>Жилые комплексы</a></li>
              </ul>
            </li>

            <li>
              <a className='hidden-sm' data-title='Цены' href='/office/statistic/'>
                <span>Цены</span>
              </a>
            </li>
            <li>
              <a className='hidden-sm' data-title='Риэлторы' href='/rieltory/'>
                <span>Риэлторы</span>
              </a>
            </li>
            <li>
              <a className='hidden-sm' data-title='Статьи' href='/articles/'>
                <span>Статьи</span>
              </a>
            </li>

            <li className={`popup-menu hidden-lg${moreClass}`}>
              <div data-title='Еще'>
                <span>Еще</span>
              </div>
              <ul className='popup'>
                <li><a href='/office/statistic/'>Цены</a></li>
                <li><a href='/rieltory/'>Риэлторы</a></li>
                <li><a href='/articles/'>Статьи</a></li>
              </ul>
            </li>
          </ul>
        </nav>

        <UserMenu />
      </header>
    );
  }
}

MainMenu.propTypes = {
  user: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

function mapStateToProps (state) {
  return {
    user: state.get('user')
  };
}

export default withRouter(connect(mapStateToProps)(MainMenu));



// WEBPACK FOOTER //
// ./src/ui/Menu/MainMenu.js